import { render, staticRenderFns } from "./step02.vue?vue&type=template&id=632d5667"
import script from "./step02.vue?vue&type=script&lang=js"
export * from "./step02.vue?vue&type=script&lang=js"
import style0 from "./step02.vue?vue&type=style&index=0&id=632d5667&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports